// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2kXBY","resendInfoText":"OnGoingPaymentBox_resendInfoText__ZytW3"};